import type { InputRouter } from "../../ui/input/router.ts";
import { pageKeys, type KeyTable } from "../controls/page.ts";
import { actionPress } from "../controls/press.ts";
import type { BarPages } from "./pages.ts";

/**
 * The swap control's key (P1.9-T133; ADR-061's note for P1.9-T133, ADR-121 decision 8.4): the key the page's key table
 * binds Swap bar page to, "`" by default, shows the other page of a paged bar while the game owns the keyboard, so
 * never while a text field has focus or a modal holds the keys, and whatever surface that is not modal is open. Where
 * the bar shows all ten, an auto-repeat, or a press with Ctrl, Alt or Meta held, the key is left alone.
 */

/**
 * Binds the swap control's key to the page's input router and the bar's pages.
 *
 * @param pages The bar's pages.
 * @param input The page's input router.
 * @param keys The key table, whose Swap bar page key swaps; the page's unless given.
 * @returns A function that unbinds the key.
 * @example
 * bindPageKeys(bar.pages, input);
 */
export function bindPageKeys(pages: Pick<BarPages, "swap">, input: Pick<InputRouter, "onKey">, keys: Pick<KeyTable, "actionOf"> = pageKeys): () => void {
  return input.onKey((event) => {
    if (event.repeat || event.defaultPrevented || event.ctrlKey === true || event.altKey === true || event.metaKey === true || !actionPress(keys, "swapPage", event)) {
      return;
    }
    if (pages.swap()) {
      event.preventDefault();
    }
  });
}
